import {initializeApp} from "firebase/app";
// Import the functions you need from the SDKs you need
// https://firebase.google.com/docs/web/setup#available-libraries
import {
  connectAuthEmulator,
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  connectFirestoreEmulator
} from 'firebase/firestore'
import {readDBPreferences, writeDBPreferences} from "./db.fb.preferences.mjs";
import {readAllTags, writeTag} from "./db.fb.tags.mjs";
import {signInWithPopup} from "@firebase/auth";

const isLocalhost = window.location.hostname === 'localhost';
const isAcceptanceMode = isLocalhost && window.location.port === '18000';

function initializeServices() {
  const useEmulator = isLocalhost;
  const useAcceptanceEmulators = isAcceptanceMode;
  const authEmulatorPort = useAcceptanceEmulators ? 19099 : 9099;
  const firestoreEmulatorPort = useAcceptanceEmulators ? 18080 : 8080;

  const firebaseConfig = document.location.hostname === 'staging.gotomyhead.site' ? {
    apiKey: "AIzaSyDpe6BFFhAg_GmwaCD04K5pMVH3W0Lhcgo",
    authDomain: "go-to-my-head.firebaseapp.com",
    databaseURL: "https://go-to-my-head-default-rtdb.firebaseio.com",
    projectId: "go-to-my-head",
    storageBucket: "go-to-my-head.firebasestorage.app",
    messagingSenderId: "414557686423",
    appId: "1:414557686423:web:26ee317231a003b247b7d2"
  } : {
    apiKey: "AIzaSyCJpXkN7d9UursADdGRXNxNZNAiGm9v7Cs",
    authDomain: useEmulator ? `localhost:${authEmulatorPort}` : "go-to-my-head.firebaseapp.com",
    projectId: "go-to-my-head",
    appId: "1:414557686423:web:b3e69c507031909247b7d2",
    databaseURL: useEmulator ? `http://localhost:${firestoreEmulatorPort}` : "https://go-to-my-head-default-rtdb.firebaseio.com/",
  };

  const app = initializeApp(firebaseConfig)

  // Always enable offline persistence so Firestore reads work from IndexedDB
  // cache when the browser is offline — including in acceptance/emulator mode.
  const db = initializeFirestore(app, {
    localCache: persistentLocalCache({tabManager: persistentMultipleTabManager()})
  });

  if (useEmulator) {
    const auth = getAuth(app);
    connectAuthEmulator(auth, `http://localhost:${authEmulatorPort}`)
    connectFirestoreEmulator(db, "localhost", firestoreEmulatorPort)
  }

  return app
}

window.firebaseApp = initializeServices()
const auth = getAuth(window.firebaseApp);

const signInButton = document.getElementById('sign-in')
signInButton.addEventListener('click', startAuthFlow, false);

if (isAcceptanceMode)
  setUpAcceptanceSignInForm()
else
  onAuthStateChanged(auth, updateAuthUI)

let count = 1
onAuthStateChanged(auth, setWindowToReflectAuthState)


function updateAuthUI(user) {
  if (user) {
    // User is signed in.
    const displayName = user.displayName;
    const email = user.email;
    const emailVerified = user.emailVerified;
    const photoURL = user.photoURL;
    const isAnonymous = user.isAnonymous;
    const uid = user.uid;
    const providerData = user.providerData;
    console.log({displayName, email, emailVerified, photoURL, isAnonymous, uid, providerData})

    signInButton.textContent = window.outerWidth > 512 ? '« Sign out' : '«';
  } else {
    signInButton.textContent = window.outerWidth > 512 ? 'Sign in »' : '»'; //'➲'
  }
  signInButton.disabled = false;
}

async function setWindowToReflectAuthState(user) {
  window.firebaseUser = user
  if (user) {
    window.readAllTaggings = readAllTags
    window.writeSongTaggings = writeTag
    window.writeDBPreferences = writeDBPreferences.bind(null, user)
    window.readDBPreferences = readDBPreferences.bind(null, user)
  } else {
    window.readAllTaggings = null
    window.writeSongTaggings = null
    window.writeDBPreferences = null
    window.readDBPreferences = null
  }

  document.dispatchEvent(new CustomEvent('authStateChanged', {detail: {count, user}}))
  window.authStateChanged = true // for integration tests
  count += 1
}

function startAuthFlow() {
  if (!auth.currentUser) {
    // if (isAcceptanceMode) {
    //   acceptanceEmailInput?.focus()
    //   return;
    // }
    const provider = new GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/plus.login');
    signInWithPopup(auth, provider);
  } else {
    signOut(auth);
  }
  signInButton.disabled = true;
}


function setUpAcceptanceSignInForm() {
  const acceptanceAuthForm = document.getElementById('acceptance-auth')
  const acceptanceEmailInput = document.getElementById('acceptance-email')
  const acceptancePasswordInput = document.getElementById('acceptance-password')

  if (isAcceptanceMode && acceptanceAuthForm) {
    acceptanceAuthForm.style.display = 'flex'
  }
  acceptanceAuthForm?.addEventListener('submit', signInWithAcceptanceCredentials, false);


  async function signInWithAcceptanceCredentials(event) {
    event.preventDefault();
    if (!isAcceptanceMode || auth.currentUser) return;

    const email = acceptanceEmailInput?.value?.trim();
    const password = acceptancePasswordInput?.value ?? "";
    if (!email || !password) {
      throw new Error("Acceptance login requires email and password");
    }

    const submitButton = document.getElementById('acceptance-sign-in');
    submitButton.disabled = true;
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      window.__acceptanceLoginError = {
        code: error?.code ?? "unknown",
        message: error?.message ?? String(error),
      };
      console.error(error);
      throw error;
    } finally {
      acceptanceAuthForm.style.display = 'none'
    }
  }

  onAuthStateChanged(auth, function (user) {
    updateAuthUI(user)
    acceptanceAuthForm.hidden = !!user;
  })
}


/*
// Result from Redirect auth flow.
getRedirectResult(auth)
  .then(function (result) {
    if (!result) return;
    // const credential = GoogleAuthProvider.credentialFromResult(result);
    // if (credential) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      // const token = credential?.accessToken;
    // }
    // The signed-in user info.
    // const user = result.user;

  })
  .catch(function (error) {
    // Handle Errors here.
    const errorCode = error.code;
    // const errorMessage = error.message;
    // The email of the user's account used.
    // const email = error.email;
    // The firebase.auth.AuthCredential type that was used.
    // const credential = error.credential;
    if (errorCode === 'auth/account-exists-with-different-credential') {
      alert(
        'You have already signed up with a different auth provider for that email.',
      );
      // If you are using multiple auth providers on your app you should handle linking
      // the user's accounts here.
    } else {
      console.error(error);
    }
  });
*/